import { render, staticRenderFns } from "./UpdateInvoiceModal.vue?vue&type=template&id=53cc3fc6&scoped=true"
import script from "./UpdateInvoiceModal.vue?vue&type=script&lang=js"
export * from "./UpdateInvoiceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cc3fc6",
  null
  
)

export default component.exports